
define('text!templates/widgets/currency/item.ejs',[],function () { return '<a href="javascript:void(0);">\n    <span><%= name %></span>\n    <i><%= money(value) %></i>\n</a>';});

